import { Link, useNavigate } from "react-router-dom";
import { LogOut, Shield } from "lucide-react";
import { useAuth } from "../lib/auth";
import { useI18n } from "../lib/i18n";
import LangSwitcher from "./LangSwitcher";

export default function Navbar() {
  const { isLoggedIn, isAdmin, logout, user } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-black/60 border-b border-white/10">
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center">
          <img src="/logos/hub-logo.png" alt="NAŠA HUB" className="h-9 w-auto object-contain" />
        </Link>

        <div className="flex items-center gap-2 sm:gap-4">
          <LangSwitcher />
          {isAdmin && (
            <Link
              to="/admin"
              data-testid="nav-admin"
              className="hidden sm:flex items-center gap-1.5 font-mono text-xs text-nhorange hover:text-glow-orange transition-colors px-2 py-1"
            >
              <Shield className="w-4 h-4" /> {t("nav_admin")}
            </Link>
          )}
          {isLoggedIn ? (
            <button
              onClick={handleLogout}
              data-testid="nav-logout"
              className="flex items-center gap-1.5 font-mono text-xs text-white/70 hover:text-nhgreen transition-colors px-3 py-1.5 border border-white/15 rounded-md"
            >
              <LogOut className="w-4 h-4" />
              <span className="hidden sm:inline">{t("nav_logout")}</span>
            </button>
          ) : (
            <>
              <Link
                to="/login"
                data-testid="nav-login"
                className="font-mono text-xs text-white/70 hover:text-white transition-colors px-2 py-1.5"
              >
                {t("nav_login")}
              </Link>
              <Link
                to="/register"
                data-testid="nav-register"
                className="font-mono font-bold text-xs bg-nhgreen text-black rounded-md px-3 sm:px-4 py-2 hover:bg-[#1ee068] hover:shadow-[0_0_15px_rgba(34,255,119,0.4)] transition-[background-color,box-shadow] duration-200"
              >
                {t("nav_register")}
              </Link>
            </>
          )}
        </div>
      </nav>
    </header>
  );
}
